// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .header-container .dynamic-side-nav-toggle ::ng-deep svg {
  stroke: #4a4a4a;
  transform: scale(1.5);
}
::ng-deep .notification-menu-toggle .mat-badge-content {
  right: -5px !important;
  left: auto !important;
  font-size: 7px !important;
}
::ng-deep .user-menu-toggle {
  font-weight: 200;
}

::ng-deep .user-menu .mat-mdc-menu-content {
  padding: 0;
}
::ng-deep .user-menu .header {
  background-color: #1e1e2d;
  padding: 1.5rem 1rem;
  position: sticky;
  top: 0;
  z-index: 50;
  color: white;
}
::ng-deep .user-menu .header .profile-picture {
  width: 55px;
  margin-right: 1.4rem;
  border: 2px solid white;
  padding: 3px;
  border-radius: 100%;
}
::ng-deep .user-menu .user-menu-item {
  display: flex;
  align-items: center;
  padding: 1rem;
  padding-right: 1.6rem;
}
::ng-deep .user-menu .user-menu-item .inner-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}
::ng-deep .user-menu .user-menu-item .inner-container .title {
  font-size: 13px;
  margin-bottom: 0.5rem;
  font-weight: 500;
}
::ng-deep .user-menu .user-menu-item .inner-container .description {
  font-size: 11px;
  font-weight: 200;
}
::ng-deep .user-menu .user-menu-item:hover:not([disabled]) mat-icon,
::ng-deep .user-menu .user-menu-item:hover:not([disabled]) .title {
  color: #5d78ff;
}
::ng-deep .notification-menu .mat-mdc-menu-content {
  padding: 0;
}
::ng-deep .notification-menu .header {
  background-color: #1e1e2d;
  padding: 1.5rem 1rem;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 50;
  color: white;
}
::ng-deep .notification-menu .header mat-icon {
  margin-right: 1rem;
}
::ng-deep .notification-menu .header h5 {
  color: white;
  margin: 0;
}
::ng-deep .notification-menu .notifications-menu-items-container {
  max-height: 200px;
  overflow-y: auto;
}
::ng-deep .notification-menu .notifications-menu-items-container .notification-menu-item {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e0e0e0;
  padding: 1rem !important;
  padding-right: 0.5rem !important;
}
::ng-deep .notification-menu .notifications-menu-items-container .notification-menu-item .status {
  color: #4a4a4a;
  margin-right: 1rem;
}
::ng-deep .notification-menu .notifications-menu-items-container .notification-menu-item .inner-container {
  flex: 1;
}
::ng-deep .notification-menu .notifications-menu-items-container .notification-menu-item .inner-container .title {
  font-size: 11px;
  word-break: break-word;
}
::ng-deep .notification-menu .notifications-menu-items-container .notification-menu-item .inner-container .description {
  font-size: 9px;
}
::ng-deep .notification-menu .notifications-menu-items-container .notification-menu-item[disabled] {
  opacity: 100%;
}
::ng-deep .notification-menu .notifications-menu-items-container .notification-menu-item.has-route {
  cursor: pointer;
}
::ng-deep .notification-menu .notifications-menu-items-container .notification-menu-item.has-route:hover mat-icon,
::ng-deep .notification-menu .notifications-menu-items-container .notification-menu-item.has-route:hover .title {
  color: #5d78ff;
}
::ng-deep .notification-menu .notifications-menu-items-container .notification-menu-item.has-route:after {
  display: block;
}
::ng-deep .notification-menu .notification-clear-item {
  padding: 1rem !important;
}
::ng-deep .dark-mode .user-menu .header,
::ng-deep .dark-mode .notification-menu .header {
  background-color: #171717;
}
::ng-deep .dark-mode .notification-menu .notifications-menu-items-container .notification-menu-item {
  border-bottom: 1px solid #4a4a4a !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/header/header.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAWI;EACC,eCiBY;EDhBZ,qBAAA;AAVL;AAiBE;EACC,sBAAA;EACA,qBAAA;EACA,yBAAA;AAfH;AAmBC;EACC,gBAAA;AAjBF;;AAwBE;EACC,UAAA;AArBH;AAwBE;EACC,yBCjC6B;EDkC7B,oBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;AAtBH;AAwBG;EACC,WAAA;EACA,oBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;AAtBJ;AAyCE;EACC,aAAA;EACA,mBAAA;EACA,aAAA;EACA,qBAAA;AAvCH;AAyCG;EACC,WAAA;EACA,aAAA;EACA,sBAAA;AAvCJ;AAyCI;EACC,eAAA;EACA,qBAAA;EACA,gBAAA;AAvCL;AA0CI;EACC,eAAA;EACA,gBAAA;AAxCL;AA8CK;;EAEC,cCvF2B;AD2CjC;AAqDE;EACC,UAAA;AAnDH;AAsDE;EACC,yBCzG6B;ED0G7B,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;AApDH;AAsDG;EACC,kBAAA;AApDJ;AAuDG;EACC,YAAA;EACA,SAAA;AArDJ;AAyDE;EACC,iBAAA;EACA,gBAAA;AAvDH;AAyDG;EACC,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,wBAAA;EACA,gCAAA;AAvDJ;AAyDI;EACC,cClHY;EDmHZ,kBAAA;AAvDL;AA0DI;EACC,OAAA;AAxDL;AA0DK;EACC,eAAA;EACA,sBAAA;AAxDN;AA2DK;EACC,cAAA;AAzDN;AA8DI;EACC,aAAA;AA5DL;AA+DI;EACC,eAAA;AA7DL;AAgEM;;EAEC,cChK0B;ADkGjC;AAkEK;EACC,cAAA;AAhEN;AAsEE;EACC,wBAAA;AApEH;AA2EG;;EACC,yBCvLiC;AD+GrC;AA8EI;EACC,2CAAA;AA5EL","sourcesContent":["@import '../../../../styles/colors';\n\n::ng-deep {\n\t.header-container {\n\t\tbutton {\n\t\t\tmat-icon {\n\t\t\t}\n\t\t}\n\n\t\t.dynamic-side-nav-toggle {\n\t\t\t::ng-deep {\n\t\t\t\tsvg {\n\t\t\t\t\tstroke: $very-dark-gray;\n\t\t\t\t\ttransform: scale(1.5);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.notification-menu-toggle {\n\t\t.mat-badge-content {\n\t\t\tright: -5px !important;\n\t\t\tleft: auto !important;\n\t\t\tfont-size: 7px !important;\n\t\t}\n\t}\n\n\t.user-menu-toggle {\n\t\tfont-weight: 200;\n\t}\n}\n\n::ng-deep {\n\t// User menu from header file\n\t.user-menu {\n\t\t.mat-mdc-menu-content {\n\t\t\tpadding: 0;\n\t\t}\n\n\t\t.header {\n\t\t\tbackground-color: $main-sidenav-background-color;\n\t\t\tpadding: 1.5rem 1rem;\n\t\t\tposition: sticky;\n\t\t\ttop: 0;\n\t\t\tz-index: 50;\n\t\t\tcolor: white;\n\n\t\t\t.profile-picture {\n\t\t\t\twidth: 55px;\n\t\t\t\tmargin-right: 1.4rem;\n\t\t\t\tborder: 2px solid white;\n\t\t\t\tpadding: 3px;\n\t\t\t\tborder-radius: 100%;\n\t\t\t}\n\n\t\t\t.inner {\n\t\t\t\t.name {\n\t\t\t\t}\n\n\t\t\t\t.email {\n\t\t\t\t\tmat-icon {\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.role {\n\t\t\t\t\tmat-icon {\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.user-menu-item {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tpadding: 1rem;\n\t\t\tpadding-right: 1.6rem;\n\n\t\t\t.inner-container {\n\t\t\t\twidth: 100%;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\n\t\t\t\t.title {\n\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\tmargin-bottom: 0.5rem;\n\t\t\t\t\tfont-weight: 500;\n\t\t\t\t}\n\n\t\t\t\t.description {\n\t\t\t\t\tfont-size: 11px;\n\t\t\t\t\tfont-weight: 200;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&:hover {\n\t\t\t\t&:not([disabled]) {\n\t\t\t\t\tmat-icon,\n\t\t\t\t\t.title {\n\t\t\t\t\t\tcolor: $main-sidenav-icon-active-color;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t// Notification menu from header file\n\t.notification-menu {\n\t\t.mat-mdc-menu-content {\n\t\t\tpadding: 0;\n\t\t}\n\n\t\t.header {\n\t\t\tbackground-color: $main-sidenav-background-color;\n\t\t\tpadding: 1.5rem 1rem;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tposition: sticky;\n\t\t\ttop: 0;\n\t\t\tz-index: 50;\n\t\t\tcolor: white;\n\n\t\t\tmat-icon {\n\t\t\t\tmargin-right: 1rem;\n\t\t\t}\n\n\t\t\th5 {\n\t\t\t\tcolor: white;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\t\t}\n\n\t\t.notifications-menu-items-container {\n\t\t\tmax-height: 200px;\n\t\t\toverflow-y: auto;\n\n\t\t\t.notification-menu-item {\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tborder-bottom: 1px solid $very-light-gray;\n\t\t\t\tpadding: 1rem !important;\n\t\t\t\tpadding-right: 0.5rem !important;\n\n\t\t\t\t.status {\n\t\t\t\t\tcolor: $very-dark-gray;\n\t\t\t\t\tmargin-right: 1rem;\n\t\t\t\t}\n\n\t\t\t\t.inner-container {\n\t\t\t\t\tflex: 1;\n\n\t\t\t\t\t.title {\n\t\t\t\t\t\tfont-size: 11px;\n\t\t\t\t\t\tword-break: break-word;\n\t\t\t\t\t}\n\n\t\t\t\t\t.description {\n\t\t\t\t\t\tfont-size: 9px;\n\t\t\t\t\t\t// color: $very-dark-gray;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t&[disabled] {\n\t\t\t\t\topacity: 100%;\n\t\t\t\t}\n\n\t\t\t\t&.has-route {\n\t\t\t\t\tcursor: pointer;\n\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tmat-icon,\n\t\t\t\t\t\t.title {\n\t\t\t\t\t\t\tcolor: $main-sidenav-icon-active-color;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.notification-clear-item {\n\t\t\tpadding: 1rem !important;\n\t\t}\n\t}\n\n\t.dark-mode {\n\t\t.user-menu,\n\t\t.notification-menu {\n\t\t\t.header {\n\t\t\t\tbackground-color: $main-sidenav-background-color-dark;\n\t\t\t}\n\t\t}\n\n\t\t.notification-menu {\n\t\t\t.notifications-menu-items-container {\n\t\t\t\t.notification-menu-item {\n\t\t\t\t\tborder-bottom: 1px solid $very-dark-gray !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n","$primary-accent: #5867dd;\n$primary-success: #65af40;\n$primary-warning: #edb95e;\n$primary-danger: #e23636;\n$warning-alt: #ff6a00;\n\n// Side nav\n$main-sidenav-background-color: #1e1e2d;\n$main-sidenav-background-color-dark: #171717;\n$main-sidenav-text-color: #a2a3b7;\n$main-sidenav-icon-color: #494b74;\n$main-sidenav-icon-active-color: #5d78ff;\n\n$content-background: #f2f3f8;\n$content-background-dark: #212121;\n$component-background-dark: #424242; // This color variable is used to match material components background in dark mode\n\n$link-color: #5d8aa8;\n\n$table-row-highlight: #646c9a;\n\n// Grays\n$lightest-gray: #f5f5f5; // Best for large backgrounds in light themes\n$very-light-gray: #e0e0e0; // Great for dividers, light backgrounds, and disabled fields\n$lighter-gray: #cccccc; // Ideal for borders, muted dividers, and secondary backgrounds\n$light-gray: #b3b3b3; // Perfect for placeholder text, disabled buttons, and icons\n$mid-gray: #a0a0a0; // Suitable for secondary text, icons, and borders\n$dark-gray: #757575; // Great for body text and interactive elements\n$darker-gray: #606060; // Works well for headings, buttons, and nav bars\n$very-dark-gray: #4a4a4a; // Ideal for headings, buttons, or background contrast\n$darkest-gray: #2d2d2d; // Perfect for high-contrast text, CTAs, and dark backgrounds\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
